import React from 'react';
import {
  Backdrop, Modal,
} from '@material-ui/core';

import ShopifyConnectForm from './ShopifyConnectForm';
import useStyles from './ShopifyFormModal.styles';

const ShopifyFormModal = ({ isOpen, close, closeAndShowProducts }) => {
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={close}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.modal}
    >
      <div className={classes.paper}>
        <div className={classes.content}>
          <div
            className={classes.closeIcon}
            onClick={close}
          >
            ×
          </div>
          <ShopifyConnectForm close={closeAndShowProducts} />
        </div>
      </div>
    </Modal>
  );
};

export default ShopifyFormModal;
